import { elements } from '#components/generics/js/styles.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import all from '@mailobj-browser/front/js/selectors/all.js'

const onChange = object(listener, {
  type: input,
  passive,
  task: (select) => {
    const { ownerDocument } = select
    const value = select.options[select.selectedIndex].value
    const theme = one('.ea_designsystem__prefs_theme', ownerDocument)
    const themeControl = one('.ea_designsystem__prefs_theme_control', ownerDocument)
    const { documentElement } = ownerDocument
    const { dataset } = documentElement
    const { skin } = dataset
    const iconsUse = all(`.${elements.icon_use}`, ownerDocument)
    let newIconsFilename
    let oldIconsFilename

    themeControl.value = 'default'
    ownerDocument.documentElement.dataset.theme = 'default'
    themeControl.options[0].value = 'default'
    themeControl.options[0].innerHTML = 'Par défaut'
    ownerDocument.documentElement.dataset.skin = select.options[select.selectedIndex].value

    if (value === 'default') {
      theme.classList.remove('ea_utilities__display-none')
      newIconsFilename = 'icons_2020'
    } else {
      theme.classList.add('ea_utilities__display-none')
      if (value === 'junior') {
        newIconsFilename = 'icons_junior'
      }
      if (value === 'kid') {
        newIconsFilename = 'icons_kid'
      }
    }

    if (skin === 'default') {
      oldIconsFilename = 'icons_2020'
    }
    if (skin === 'junior') {
      oldIconsFilename = 'icons_junior'
    }
    if (skin === 'kid') {
      oldIconsFilename = 'icons_kid'
    }

    if (iconsUse) {
      for (const iconUse of iconsUse) {
        const href = iconUse.getAttribute('href')
        const newHref = href.replace(oldIconsFilename, newIconsFilename)
        iconUse.setAttribute('href', newHref)
      }
    }
  }
})

export default select => {
  onChange.listen(select)
}
